import React, { useState , useEffect} from 'react';
import './css/SectionByDate.css';
import Card from './Card';

function Section({item, editContent, index}) {
  // console.log(typeof editContent, editContent.red);
  let {date, red, green, blue} = item;
  let [editable, setEditable] = useState(false);  //toggle if note can be edited
  let [firstScroll, setFirstScroll] = useState(false); //toggle visibility for date

  const scrollHandler = () => {
    setFirstScroll(window.scrollY > 0 ? true : false);
  }

  useEffect(() => {
    //toggle date visibility in list
    document.addEventListener('scroll', scrollHandler);
    return () => {
      document.removeEventListener('scroll', scrollHandler);
    }
  }, [])

  return(
        <div className="day">
          <div className={firstScroll ? "dateBar" : "dateBar hide"}>
            <span>{date}</span>
            <i className={editable ? "fa fa-check" : "fa fa-pencil"} aria-hidden="true" onClick={()=>setEditable(!editable)}></i>
          </div>
          <div className="cardContainer">

          {
            (red || red==='') && 
              <Card 
              editable={editable} 
              color={'red'} 
              index={index} 
              content={red} 
              editContent={editContent}
              />
          }

          {
            (blue || blue==='') && 
              <Card 
              editable={editable} 
              color={'blue'} 
              index={index} 
              content={blue} 
              editContent={editContent}
              />
          }

          {
            (green || green==='') && 
              <Card 
              editable={editable} 
              color={'green'} 
              index={index} 
              content={green} 
              editContent={editContent}
              />
          }

          </div>
        </div>
    )
}

export default Section;